import { atom } from 'recoil';

export const defaultOverlayState = { class: '', render: null };

export const overleyState = atom({
	key: 'overley',
	default: { class: '', render: null },
});
